// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2e-g3","title":"FrontImage_title__3T8PY"};